import styled from 'styled-components';

export const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleStyled = styled.h4`
  margin-bottom: 8px;
`;

export const TextStyled = styled.span`
  margin-bottom: 16px;
`;
